<template>
  <div id="pageRoot">
    <span class="normalTheme pageInstruction" style="left: 50px; top: 118px">
      <p>Completa cada enunciado eligiendo una de estas palabras:</p>
    </span>

    <p id="tag01" class="textBase basicItem01 tagDefault">porque</p>
    <p id="tag02" class="textBase basicItem01 tagDefault">además</p>
    <p id="tag03" class="textBase basicItem01 tagDefault">aunque</p>

    <h2 id="text01" class="textBase textFormat">
      Los castillos daban vivienda a las personas y <br />servían como
      fortalezas militares.
    </h2>
    <h2 id="text02" class="textBase textFormat">
      La muralla y el foso que rodeaban el castillo<br />
      protegían a sus habitantes ______________ eran frecuentes<br />
      los ataques enemigos.
    </h2>
    <h2 id="text03" class="textBase textFormat">
      En la actualidad, los castillos estan<br />
      deshabitados _______________ reciben a los turistas<br />
      que desean visitarlos.
    </h2>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="4"
      id="inputField04"
    />
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 52px;
  top: 118px;
}
#tag01 {
  position: absolute;
  width: 180px;
  text-align: center;
  left: 93px;
  top: 184px;
}
#tag02 {
  position: absolute;
  width: 180px;
  text-align: center;
  left: 338px;
  top: 184px;
}
#tag03 {
  position: absolute;
  width: 180px;
  text-align: center;
  left: 576px;
  top: 184px;
}
#text01 {
  position: absolute;
  left: 55px;
  top: 287px;
}
#text02 {
  position: absolute;
  left: 55px;
  top: 417px;
}
#text03 {
  position: absolute;
  left: 55px;
  top: 588px;
}
.textFormat {
  font-size: 29px;
  text-transform: uppercase;
  line-height: 1.6;
}
#inputField02 {
  position: absolute;
  width: 170px;
  height: 35px;
  left: 770px;
  top: 282px;
  z-index: 3;
}
#inputField03 {
  position: absolute;
  width: 160px;
  height: 35px;
  left: 487px;
  top: 457px;
  z-index: 3;
}
#inputField04 {
  position: absolute;
  width: 175px;
  height: 35px;
  left: 276px;
  top: 626px;
  z-index: 3;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "cas/Video 146.mp4",
        "cas/Video 147.mp4",
        "cas/Video 148.mp4",
        "cas/Video 149.mp4",
        "cas/Video 150.mp4",
        "cas/Video 151.mp4",
        "cas/Video 152.mp4",
      ],
    };
  },
};
</script>